import type { Step as RcStep } from '@sb/remote-control/types';

import { type ValidationRule, type RoutineView } from '../../types';
import { validateConditional } from '../../util/validators';

import { CanonicalStepRuleBase } from './base';
import type { CanonicalValidateArgs } from './base';

class LoopRule extends CanonicalStepRuleBase {
  public constructor() {
    super('steps.Loop', 'Loop');
  }

  protected validate({ args, routine }: CanonicalValidateArgs): void {
    type LArgs = Extract<RcStep.Arguments, { argumentKind: 'Loop' }>;
    const a = args as LArgs;
    this.checkCondition(a, routine);
  }

  /**
   * Validate the loop condition against the routine.
   * Throws if invalid.
   *
   * @throws {ActionRequiredError}
   */
  private checkCondition(
    args: Extract<RcStep.Arguments, { argumentKind: 'Loop' }>,
    routine: RoutineView,
  ): void {
    if (typeof args.condition !== 'string') return;
    const conditions = JSON.parse(args.condition || '[]');
    validateConditional(conditions, routine);
  }
}

export const LoopValidation: ValidationRule = new LoopRule().toValidationRule();
